import {REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE} from '/enum/records.enum';
import {EVENT_NAMES, REPORT_NAME} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

/**
 * Generates a callback to be called when the record is pressed
 *
 * @param {object} params - Parameters
 * @param {function} params.onShowProfile - A callback to show profile popover
 * @param {function} params.currentScreen
 *
 * @returns {function} Callback - A function to be called when record is pressed
 */

export function generateOnRecordPress({onShowProfile, currentScreen}: any) {
  return ({id, prospectInfoId}: any, reportName: any) => {
    onShowProfile({
      //API response for New Candidates have prospectInfoId instead of id
      id:
        REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE === reportName
          ? prospectInfoId
          : id,
      currentScreen,
      //passing reportName to configure what type of profile to show (Client/Candidate etc)
      reportName,
    });
  };
}

/**
 * Generates a callback to be called when the people to contact is pressed
 *
 * @param {object} params - Parameters
 * @param {string} params.filterType  - current people to contact filter value
 * @param {function} params.currentScreen -current screen name
 *
 * @returns {function} Callback - A function to be called when tab is pressed
 */

export function generateOnTabPress({
  filterType,
  currentScreenName,
  lastPaidRank,
  highestAchievedRank,
  coachId,
}: any) {
  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.onFilterPress,
  });

  sendEvent({
    filterType: filterType,
    currentScreenName: currentScreenName,
    reportName: REPORT_NAME.clientsToContact,
    lastPaidRank: lastPaidRank || 'na',
    highestAchievedRank: highestAchievedRank || 'na',
    coachId: `${coachId}`,
  });
}
